export default "__VITE_ASSET__Dn9g4EGj__"